import { gql, type OperationVariables } from '@apollo/client';

import GraphQL from '../graphQL';

const query = gql`
mutation updateMyLastName($lastName: String!) {
    updateMyLastName(lastName: $lastName) 
},
`;

export default async function updateMyLastName(lastName: string) {
    const variables: OperationVariables = {
        lastName,
    };
    return GraphQL.mutate<boolean>(query, variables);
}
